export class DataGridsHelper<T> {
    private currentSortColumn: string = "";
    private currentSortOrder: string = "";
    private gridData: T[] = [];
    private currentPageData: T[] = [];
    
    private pageSize:number = 10;
    private pageCount:number = 1;
    private currentPage:number = 1;

    public get CurrentPageData() {
        return this.currentPageData;
    }

    public get PageSize(): number { return this.pageSize;} 
    public set PageSize(value:number) { 
        if (value < 1)
            console.error(`Invalid page size ${value}`)

        this.pageSize = value;
        this.RecalculatePageCount();
        this.ChangePage(1);
    } 

    public set GridData(value: T[])
    { 
        this.gridData = value;
        this.RecalculatePageCount();
        this.ChangePage(1);
    } 

    public get PageCount() { return this.pageCount; }

    constructor() {}

    public SortData(column:string) 
    {
        if (this.gridData == null)
            return;
      
        if (this.currentSortColumn == column)
            this.currentSortOrder = this.currentSortOrder == "ASC" ? "DESC" : "ASC";
        else
            this.currentSortOrder = "ASC";
    
        this.currentSortColumn = column;
        if (this.currentSortOrder != "")
        {
            if (this.currentSortOrder == "ASC")
            {
                this.gridData.sort((a: any, b: any) => {
                
                if (a[this.currentSortColumn] < b[this.currentSortColumn])
                    return -1;
                if (a[this.currentSortColumn] > b[this.currentSortColumn])
                    return 1;
                return 0; 
                });
            }
            else
            {
                this.gridData.sort((a: any, b: any) => {
            
                if (a[this.currentSortColumn] < b[this.currentSortColumn])
                    return 1;
                if (a[this.currentSortColumn] > b[this.currentSortColumn])
                    return -1;
                return 0;
                });
            }

            this.ChangePage(this.currentPage);
        }
    }

    public ChangePage(pageNumber: number) {
        const pageSize: number = 50;
        const startIndex = (pageNumber - 1) * pageSize;
        const endIndex = startIndex + pageSize;

        this.currentPage = pageNumber;
        this.currentPageData = this.gridData.slice(startIndex, endIndex);
    }

    public Icon(column:string)
    {
        if (column == this.currentSortColumn)
        {
            if (this.currentSortOrder == "ASC")
                return "arrow_upward";
            return "arrow_downward";
        }
        return "";
    }

    private RecalculatePageCount():void {
        this.pageCount = Math.ceil(this.gridData?.length / (this.pageSize ?? 1));
        if (this.pageCount == 0)
            this.pageCount = 1;
    }
}